import { render } from "./QRCodeReader.vue?vue&type=template&id=49ed0f26&scoped=true"
import script from "./QRCodeReader.vue?vue&type=script&lang=js"
export * from "./QRCodeReader.vue?vue&type=script&lang=js"

import "./QRCodeReader.vue?vue&type=style&index=0&id=49ed0f26&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49ed0f26"]])

export default __exports__